import gsap from 'gsap';

import { isIOS, isMobileOrTablet } from '../helpers/features';
import { ProcessedActivity } from './declarations/Activity';
import { Coordinates } from './declarations/PositionInfo';
import { EVENT_APP_STORE_REDIRECT_CLICK, EVENT_APP_STORE_REDIRECT_IMPRESSION, sendCustomEvent } from '../helpers/stats';

//initially - root and all elements all hidden - css class hidden = display: none
export default class InfoBubble {
  private root: HTMLElement | null;
  public isVisible: boolean;
  private activity: ProcessedActivity | null;
  private onShow: null | (() => void);
  private onHide: null | (() => void);

  private title: HTMLElement | null = null;
  private closeButton: HTMLElement | null = null;
  private actionButton: HTMLElement | null = null;
  private unlockMessage: HTMLElement | null = null;
  private storeButton: HTMLElement | null = null;
  private contestIcon: HTMLElement | null = null;

  constructor(root: HTMLElement | null, onShow: (() => void) | null = null, onHide: (() => void) | null = null) {
    this.root = root;

    this.isVisible = false;
    this.activity = null;

    this.onShow = onShow;
    this.onHide = onHide;

    if (root) {
      this.title = root.querySelector('.activity-title');
      this.closeButton = root.querySelector('.close-button');
      this.actionButton = root.querySelector('.action-button');
      this.unlockMessage = root.querySelector('.unlock-message');
      this.storeButton = root.querySelector('.store-button');

      this.contestIcon = root.querySelector('.contest-icon');

      if (this.actionButton) {
        this.actionButton.addEventListener('pointerup', (e) => this.onStartOrStoreButtonClick(e));
      }
      if (this.storeButton) {
        this.storeButton.addEventListener('pointerup', (e) => this.onStartOrStoreButtonClick(e));
      }
      if (this.closeButton) {
        this.closeButton.addEventListener('pointerup', (e) => this.onCloseButtonClick(e));
      }
    }
  }

  onCloseButtonClick(e: Event) {
    this.hide();
    e.preventDefault();
  }

  onStartOrStoreButtonClick(e: Event) {
    if (this.activity) {
      if (this.activity.appLink) {
        if (this.storeButton) {
          sendCustomEvent(EVENT_APP_STORE_REDIRECT_CLICK, this.activity.linkHash);
        }
        window.open(this.activity.appLink, 'blank');
      } else {
        window.location.hash = this.activity.linkHash;
      }
    }
    this.hide();
    e.preventDefault();
  }

  show(activity: ProcessedActivity, position: Coordinates) {
    if (activity !== this.activity) {
      this.activity = activity;
      this.updateContent();
    }

    if (position) {
      gsap.set(this.root, { x: position.x, y: position.y });
    }

    this.isVisible = true;

    gsap.killTweensOf(this.root);
    gsap.set(this.root, { opacity: 0, scale: 0.5, transformOrigin: '0% 0%' }); // it was transformOrigin: "50% 50%"; changed after actvity-container-inner translate(-50%, -50%); was added
    gsap.to(this.root, { duration: 0.4, opacity: 1, ease: 'sine.out' });
    gsap.to(this.root, { duration: 0.4, scale: 1, ease: 'back.out(1.5)' });

    if (this.root) {
      this.showElement(true, this.root);
    }

    if (this.onShow) {
      this.onShow();
    }
  }

  hide() {
    if (!this.isVisible) {
      return;
    }

    this.isVisible = false;
    gsap.killTweensOf(this.root);

    gsap.to(this.root, {
      duration: 0.3,
      opacity: 0,
      onComplete: () => this.hideComplete(),
    });
    gsap.to(this.root, { duration: 0.3, scale: 0.4, ease: 'sine.in' });

    if (this.onHide) {
      this.onHide();
    }
  }

  getSize() {
    if (this.root) {
      return { w: this.root.offsetWidth, h: this.root.offsetHeight };
    } else {
      return { w: 0, h: 0 };
    }
  }

  hideComplete() {
    if (this.root) {
      this.showElement(false, this.root);
    }
  }

  showElement(doShow = true, element: HTMLElement) {
    if (doShow) {
      element.classList.remove('hidden');
    } else {
      element.classList.add('hidden');
    }
  }

  updateContent() {
    if (this.title && this.activity) {
      this.title.innerText = this.activity.title;
    }

    if (this.activity && this.contestIcon) {
      this.showElement(this.activity.isContest, this.contestIcon);
    }

    if (this.unlockMessage) {
      this.showElement(false, this.unlockMessage);
    }

    if (isMobileOrTablet && this.activity?.appLink) {
      // pokud jsem na mobilu (isMobile) a pokud je to existuje apka
      if (this.actionButton) {
        this.showElement(false, this.actionButton);
      }
      if (this.storeButton) {
        this.showElement(true, this.storeButton);
        sendCustomEvent(EVENT_APP_STORE_REDIRECT_IMPRESSION, this.activity.linkHash);
      }

      if (this.storeButton) {
        if (isIOS) {
          this.storeButton.classList.add('ios-button');
        } else {
          this.storeButton.classList.remove('ios-button');
        }
      }
    } else {
      //jinak zobraz tlacitko start s danym labelem
      if (this.storeButton) {
        this.showElement(false, this.storeButton);
      }
      if (this.actionButton) {
        this.showElement(true, this.actionButton);
      }
      if (this.actionButton && this.activity) {
        this.actionButton.innerText = this.activity.label;
      }
    }
  }
}
